import {
  fetchBaseQuery,
  BaseQueryFn,
  FetchBaseQueryError,
  FetchArgs,
} from '@reduxjs/toolkit/query/react';

const createBaseQueryWithReauth = (
  baseUrl: string,
): BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError> => {
  return async (args, api, extraOptions) => {
    const baseQuery = fetchBaseQuery({
      baseUrl: baseUrl,
      prepareHeaders: (headers) => {
        headers.set('Content-Type', 'application/json');
        headers.set(
          'Authorization',
          `Basic ${btoa(`xnd_development_UobLBtbz0IFP6Xio7NACFejBT98ylniqASTOJAeooPhSnRBKKzk0FvaLrpecY:`)}`,
        );

        return headers;
      },
      mode: 'cors',
    });

    try {
      const result: any = await baseQuery(args, api, extraOptions);
      if (result.error) {
        if (result.error.originalStatus === 401) {
          console.error(
            'Forbidden access - you might want to redirect to login',
          );
        }
        console.error('Fetch error: ', result.error);
      }
      return result;
    } catch (error: any) {
      console.error('Network error: ', error);
      return {
        error: { status: 'FETCH_ERROR', error: error.message },
      };
    }
  };
};

export default createBaseQueryWithReauth;
